import { render, staticRenderFns } from "./DocumentosForm.vue?vue&type=template&id=b01957e2"
import script from "./DocumentosForm.vue?vue&type=script&lang=js"
export * from "./DocumentosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports